import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { H6 } from '@blueprintjs/core';
import { TablePagination, Paper } from '@material-ui/core';
import MaterialTable from 'material-table';
import Chart from 'react-apexcharts';
import '../results.css';
import {estimatedClass} from '../common'
import { rounded }  from '../../../utils.js'
import { CsvBuilder } from "filefy";
import Cookies from 'js-cookie';
import { FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME } from '../../../auth/constants.js';
import {MAX_CHART_SIZE} from '../../../constants.js';

class DetailByCorpus extends React.PureComponent {


  render() {
    const { corpusStats, t, incompleteExtraction } = this.props;
    const userFrontNotLoggedIn= !(Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME));

    let type;
    let typeLabel;
    let level;
    switch (this.props.type) {
      case 'freqByCorpus':
        type = 'freq';
        typeLabel = t('frequency');
        level = 'byCorpus'
        break;
      case 'freqByDoc':
        type = 'freq';
        typeLabel = t('frequency');
        level = 'byDoc'
        break;
      case 'specByCorpus':
        type = 'specificity';
        typeLabel = t('specificity');
        level = 'byCorpus'
        break;
      case 'specByDoc':
        type = 'specificity';
        typeLabel = t('specificity');
        level = 'byDoc'
        break;
      case 'dispByCorpus':
        type = 'disp';
        level = 'byCorpus'
        typeLabel = t('dispersion');
        break;
      default:
        break;
    }


    let data = [];
    for (const corpusOrDoc in corpusStats) {
      let title=corpusOrDoc;
      
      if (corpusStats[corpusOrDoc]['title']) {
        title=corpusStats[corpusOrDoc]['title'];
      }
      const row = {
        title: title,
        value: corpusStats[corpusOrDoc][type],
      };
      data.push(row);
      
    }

    // sort data by decreasing order
    data.sort((a, b) => a.value - b.value);
    data.reverse();
    const dataChart=data.slice(0,MAX_CHART_SIZE);

    const typeLabelLower = typeLabel.toLowerCase();

    const titlesTable = (
      <MaterialTable
        columns={[
          { title: t('title'), field: 'title' },
          { title: typeLabel, field: 'value', render: rowData => <span className={estimatedClass(rowData.value,incompleteExtraction)}>{rounded(rowData.value)}</span> },
        ]}
        data={data}
        title={`${typeLabel} ${t(level)}`}
        options={{
          filtering: true,
          search: true,
          sorting: true,
          exportButton: true,
          exportFileName:`${typeLabelLower}_by_corpus`,
          exportAllData: true,
        }}
        components={{
          exportCsv: (columns, data) => {
            const fileName = typeLabelLower+"_colloc";
            const builder = new CsvBuilder(
                fileName + ".csv"
            );
            builder
                .setColumns(
                    ["name","value"]                )
                .addRows(
                  data.map((rowData) => [rowData.title,rowData.value])
                )
                .exportFile();
          },
          Pagination: props => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 25, 50, 100, data.length]}
            />
          ),
          Container: props => (
            <Paper
              {...props}
              elevation={0}
            />
          ),
        }}
      />
    );

    // prep data for the chart
    const series = [{
        name:typeLabel,
        data:dataChart.map(e=>e.value)
    }];
    const options = {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            // colors: {
            //   ranges: [{
            //     from: -100,
            //     to: -46,
            //     color: '#F15B46'
            //   }, {
            //     from: -45,
            //     to: 0,
            //     color: '#FEB019'
            //   }]
            // },
            columnWidth: '80%',
          }
        },
        dataLabels: {
          enabled: false,
        },
        yaxis: {
          title: {
            text: typeLabel,
          },
          labels: {
            formatter: function (y) {
              return rounded(y,2);
            }
          }
        },
        xaxis: {
          type: 'text',
          categories: dataChart.map(el=>(el.title)),
          labels: {
            rotate: -90
          }
        }
    };

    return(
      <>
        { 
          userFrontNotLoggedIn && 
          <p>{t('noTitleIfNotLogged')}</p>
        }  
 
        <div className="margin-bottom-1-rem">
          <H6><u>{t('graphicalRepr')}</u></H6>
            <div id="chart">
                <Chart options={options} series={series} type="bar" height={350} />
            </div>
        </div>

        <H6><u>{t('completeResList')}</u></H6>
        {titlesTable}
      </>
    );
  }
}

DetailByCorpus.propTypes = {
  corpusStats: PropTypes.object,
  type: PropTypes.string,
  incompleteExtraction:PropTypes.bool,
  performSearch: PropTypes.func,
};

export default withTranslation()(DetailByCorpus);
